var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('appHeader'),_c('transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"container"},[_c('br'),_c('br'),_c('appProductGrid')],1)]),_c('appFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }